// Shared classification + visual styles for the three reconcile tags
// (used by both the Reconcile page and the Statement page).

export const TAG_STYLES = {
  reconciled: 'bg-[#D1FAE5] text-[#065F46]', // green light bg / dark green text
  pending: 'bg-[#FFEDD5] text-[#9A3412]',     // orange light bg / dark orange text
  scheduled: 'bg-[#DBEAFE] text-[#1E40AF]',   // blue light bg / dark blue text
};

export const TAG_LABELS = {
  reconciled: 'Reconciled',
  pending: 'Pending',
  scheduled: 'Scheduled',
};

/**
 * Classify a row by date + reconciled status. Source/kind is irrelevant.
 *   Reconciled → tag = 'reconciled'
 *   Future date (> today) → tag = 'scheduled'
 *   Otherwise (date <= today, not reconciled) → tag = 'pending'
 *
 *   row: { date: 'YYYY-MM-DD', reconciled: bool }
 *   todayIso: 'YYYY-MM-DD'
 */
export const computeTag = (row, todayIso) => {
  if (row.reconciled) return 'reconciled';
  if (row.date > todayIso) return 'scheduled';
  return 'pending';
};
